import { __decorate } from "tslib";
import { E_ChargeMode, E_PackageTag, E_PrivilegeStatus } from '@/apis/service/PackageApi.types';
import { injectable } from 'inversify';
import { map, flatMap, findIndex, sortBy } from 'lodash';
import dayjs from 'dayjs';
import { CompanyOrganizationCommonService } from './CompanyOrganizationCommonService';
let CompanyPrivilegeListService = class CompanyPrivilegeListService extends CompanyOrganizationCommonService {
    constructor() {
        super(...arguments);
        this.timeType = 'YYYY-MM-DD HH:mm:ss';
    }
    async HistoryFlatten(companyPrivilege, userCanUseChargetModes) {
        /* 是否可以分配 */
        const privilegeList = flatMap(companyPrivilege, item => {
            const privilegeListItem = item.company_privilege_contract_vo_list; // 权限列表
            const packageList = item.package_vo_list; // 套餐列表
            const hasOpenAPI = findIndex(packageList, p => p.package_tag === E_PackageTag.OPEN_API) >= 0;
            if (hasOpenAPI) {
                return [];
            }
            const canEdit = this.canUsePrivilege(item, userCanUseChargetModes);
            // 忽略其中的history的package
            const hasHistoryPackage = findIndex(packageList, (p) => p.charge_modes.indexOf(E_ChargeMode.HISTORICAL) > -1) >= 0;
            const isAnonymousPrivilege = this.isAnonymousPrivilege(item);
            return map(privilegeListItem, privilege => {
                // 根据是否启用判断
                const concurrencyFix = privilege.business_package_enabled ? privilege.concurrency : null;
                return {
                    hasHistoryPackage,
                    packages: packageList,
                    status: this.getStatus(privilege),
                    ...privilege,
                    isAnonymousPrivilege,
                    concurrency: concurrencyFix,
                    canEdit,
                };
            });
        });
        // 根据创建时间倒序
        return sortBy(privilegeList, p => -p.created_at);
    }
    /* 是否过期的数据处理 */
    getStatus(privilege) {
        const { enabled, } = privilege;
        const endAtValue = privilege.end_at_value;
        if (!enabled) {
            return E_PrivilegeStatus.Disabled;
        }
        const isExpire = this.isExpireNow(endAtValue, this.timeType);
        if (isExpire) {
            return E_PrivilegeStatus.Expire;
        }
        return E_PrivilegeStatus.Normal;
    }
    isExpireNow(timeStr, format) {
        const expire = dayjs(timeStr, format);
        return expire.isBefore(dayjs());
    }
    getCompanyPrivilegeManagerData(id) {
        const companyPrivilege = this.getCompanyPrivilege(id);
        const userCanUseChargetModes = this.getPackageChargetModes();
        return Promise.all([companyPrivilege, userCanUseChargetModes])
            .then(([companyPrivilegeRes, userCanUseChargetModesRes]) => {
            return this.HistoryFlatten(companyPrivilegeRes, userCanUseChargetModesRes);
        });
    }
    setEnableOrDisablePrivilege(privilege_id, privilege_enable) {
        if (privilege_enable) {
            return this.PackageApi.patchDisablePrivilege(privilege_id);
        }
        return this.PackageApi.patchEnablePrivilege(privilege_id);
    }
};
CompanyPrivilegeListService = __decorate([
    injectable()
], CompanyPrivilegeListService);
export { CompanyPrivilegeListService };
